<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Manual from "@/models/manual.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Manual.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/manual/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/manual/novo`);
			},
			searchEntities(paginationParameters) {
				return Manual.search(paginationParameters);
			},
		},
	}
</script>
